import { CollectionUtils, RecordUtils } from "@rsm-hcd/javascript-core";
import Notebook from "../interfaces/notebook";
import { Record } from "immutable";
import UserRecord from "./user-record";
import PageRecord from "./page-record";

const defaultValues: Notebook =
    RecordUtils.auditableDefaultValuesFactory<Notebook>({
        name: "",
        owner: undefined,
        ownerId: 0,
        isNewlyShared: false,
        pages: [],
    });

export default class NotebookRecord
    extends Record(defaultValues)
    implements Notebook
{
    constructor(params?: Partial<Notebook>) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        if (params.owner != null) {
            params.owner = RecordUtils.ensureRecord(params.owner, UserRecord);
        }

        if (CollectionUtils.hasValues(params.pages)) {
            params.pages = params.pages?.map((p) =>
                RecordUtils.ensureRecord(p, PageRecord)
            );
        }

        super(params);
    }

    public get sortedPages() {
        return CollectionUtils.sortByString(
            this.pages ?? [],
            (page) => page.name,
            false
        );
    }

    public isSharedPagesNotebook(): boolean {
        return !!this.id;
    }

    public with(values: Partial<Notebook>): NotebookRecord {
        return new NotebookRecord(Object.assign(this.toJS(), values));
    }
}
